import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './TabContent.css';

const RatingsTab = ({ userDetails }) => {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [reviewerNames, setReviewerNames] = useState({});

    useEffect(() => {
        if (!userDetails?.id) return;

        const fetchReviews = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080'}/review/${userDetails.id}`);
                setReviews(response.data);
                const uniqueReviewerIds = [...new Set(response.data.map(r => r.reviewer_id))];
                const names = {};
                await Promise.all(uniqueReviewerIds.map(async (id) => {
                    if (!id) return;
                    try {
                        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080'}/users/${id}`);
                        names[id] = res.data.firstname + ' ' + res.data.lastname;
                    } catch {
                        names[id] = 'Unknown';
                    }
                }));
                setReviewerNames(names);
            } catch (error) {
                console.error('Error fetching reviews:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchReviews();
    }, [userDetails]);

    const renderStars = (rating) => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <span
                    key={i}
                    style={{
                        color: i <= rating ? '#FFD700' : '#e0e0e0',
                        fontSize: '2rem',
                        marginRight: '0.15em',
                        verticalAlign: 'middle',
                        filter: i <= rating ? 'drop-shadow(0 1px 2px #f7e7b6)' : 'none',
                        transition: 'color 0.2s',
                    }}
                >
                    &#9733;
                </span>
            );
        }
        return stars;
    };

    if (loading) {
        return (
            <div className="tab-content">
                <div className="loaderContainer">
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="tab-content">
            <div className="tab-header" style={{ borderBottom: 'none', marginBottom: '1.5rem' }}>
                <h2 style={{ fontWeight: 700, fontSize: '2.1rem', color: '#222', letterSpacing: '-1px' }}>Reviews</h2>
                <p style={{ color: '#888', fontSize: '1.08rem', marginTop: '0.2rem' }}>See what others have said about you</p>
            </div>
            <div style={{ width: '100%', maxWidth: 600, margin: '0 auto' }}>
                {reviews.length > 0 ? (
                    reviews.map((review, idx) => (
                        <div
                            key={review.id || idx}
                            style={{
                                background: '#fff',
                                borderRadius: '18px',
                                boxShadow: '0 2px 16px rgba(38,168,153,0.07), 0 1.5px 6px rgba(0,0,0,0.03)',
                                padding: '2.1rem 2rem 1.5rem 2rem',
                                marginBottom: '2.2rem',
                                position: 'relative',
                                border: 'none',
                                minHeight: 120,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0.7rem',
                                transition: 'box-shadow 0.2s',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', marginBottom: '0.2rem' }}>
                                {renderStars(review.rating)}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', marginBottom: '0.1rem' }}>
                                <span style={{ fontSize: '1.01rem', color: '#444', fontWeight: 500 }}>{review.comment}</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1.2rem', marginTop: '0.2rem' }}>
                                <span style={{ fontSize: '0.97rem', color: '#888', fontWeight: 400 }}>
                                    {reviewerNames[review.reviewer_id] || 'Unknown'}
                                </span>
                                <span style={{ fontSize: '0.93rem', color: '#b0b0b0', fontWeight: 400, marginLeft: 'auto' }}>
                                    {review.createdat ? new Date(review.createdat).toLocaleDateString() : ''}
                                </span>
                            </div>
                            {idx !== reviews.length - 1 && (
                                <div style={{ height: 1, background: 'linear-gradient(90deg, #e8f5f3 0%, #f0f8ff 100%)', margin: '1.2rem 0 0 0', border: 'none', opacity: 0.7 }} />
                            )}
                        </div>
                    ))
                ) : (
                    <div className="no-messages" style={{ background: 'none', color: '#bbb', fontSize: '1.1rem', boxShadow: 'none', padding: '2.5rem 0' }}>
                        <p>No reviews found.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RatingsTab; 